import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteApplicationAccountMutation} from '../hooks/useApplicationAccountsQuery';
import {useApplicationAccountsSelection} from "../hooks/useApplicationAccountsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteApplicationAccountMutation = useDeleteApplicationAccountMutation();

    const {
        selection,
        handleClearSelection,
    } = useApplicationAccountsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteApplicationAccountMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
